export default "__VITE_ASSET__D3eOZKod__"